import { SVGAttributes } from "react";

export const NofollowIcon = (
  props: SVGAttributes<SVGElement> & { size: "regular" }
) => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.207 5.293a1 1 0 00-1.414 0l-2.5 2.5a1 1 0 101.414 1.414L4.5 7.414l1.777 1.778a5.98 5.98 0 00-.265 1.425l-1.696-.566a1 1 0 00-1.148.394l-2 3a1 1 0 101.664 1.11l1.576-2.365 1.871.624c.133.42.312.821.53 1.196l-1.625.541a1 1 0 00-.541.434l-1.5 2.5a1 1 0 001.715 1.03l1.31-2.183 2.041-.681A5.975 5.975 0 0012 17a5.975 5.975 0 003.79-1.349l2.043.68 1.31 2.184a1 1 0 001.715-1.03l-1.5-2.5a1 1 0 00-.542-.434l-1.624-.541c.12-.207.228-.421.323-.643l2.614-1.12 1.54 2.308a1 1 0 001.663-1.11l-2-3a1 1 0 00-1.226-.364L18 10.983a5.997 5.997 0 00-.277-1.791L19.5 7.414l1.793 1.793a1 1 0 101.414-1.414l-2.5-2.5a1 1 0 00-1.414 0l-2.042 2.042A5.99 5.99 0 0012.001 5a5.99 5.99 0 00-4.752 2.335L5.207 5.293zm9.814 8.33c.61-.703.98-1.62.98-2.623 0-.633-.148-1.231-.41-1.763l-5.354 5.354c.532.262 1.13.409 1.763.409 1.003 0 1.92-.37 2.622-.98a.997.997 0 01.399-.398zM8 11a4 4 0 016.283-3.284l-5.568 5.568A3.981 3.981 0 018 11z"
        fill="currentColor"
      />
    </svg>
  );
};
NofollowIcon.displayName = "NofollowIcon";
